import React, { useState, useEffect } from "react";
import { elsevierStyleSheetJSfileImport, indianCurrencyFormat } from "../library/utils";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import search from "../library/svg/search.svg";
import axios from "axios";
import { backendBookartUrl } from "../library/constants";
import { Link, useNavigate } from "react-router-dom";

const OrderHistory = () => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [toggleFilter, setToggleFilter] = useState(true);
  const [order, setOrder] = useState([]);
  const [totalProducts, setTotalProducts] = useState([]);
  const [dropDownYears, setDropDownYears] = useState([]);
  const [filterLabel, setFilterLabel] = useState("Recent");
  const [auth, setAuth] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    authUser(); // Authenticate User
    elsevierStyleSheetJSfileImport();
    getOrderData();
    fetchYears();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchYears = () => {
    var initialYear = 2022;
    var currentYear = new Date().getFullYear();
    var years = [];
    for (let i = initialYear; i <= currentYear; i++) years.push(i);
    setDropDownYears(years);
  };

  const getOrderData = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    var config = {
      method: "post",
      url: `${backendBookartUrl}/view_order_history?=`,
      headers: {
        "Authorization":`Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response) => {
        let orders = response.data.order_history;
        setOrder(orders);
        setTotalProducts(orders);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    if (token === null) {
      navigate("/");
      } else {
        setAuth(true);
      }
  };

  const findProducts = () => {
    let product = totalProducts.filter((element) => {
      if (searchKeyword.trim() === "") {
        return totalProducts;
      }
      return searchKeyword.trim().toLowerCase() === element.order_number.toLowerCase();
    });
    setOrder(product);
  };

  const formattedDate = (data) => {
    let splittedDate = data.split(" ");
    splittedDate = splittedDate[1] + " " + splittedDate[2] + " " + splittedDate[3];
    return splittedDate;
  };

  const handleChange = (event) => {
    setSearchKeyword(event.target.value);
  };

  const toggleFiltering = () => {
    setToggleFilter(!toggleFilter);
  };

  const handleFiltering = (event) => {
    let time = event.currentTarget.innerText;
    let sortedData = [];

    setFilterLabel(time);
    setToggleFilter(!toggleFilter);

    if (time === "Last week") {
      let today = new Date();
      let lastWeek = new Date();
      lastWeek.setDate(today.getDate() - 7); // Set date as last 7 days
      lastWeek.setHours(0, 0, 0, 0); // Set Time as 00:00 hrs
      sortedData = totalProducts.filter((product) => {
        let productDateTime = new Date(product.order_date).getTime();
        return productDateTime >= lastWeek.getTime() && productDateTime <= today.getTime();
      });
    }

    if (time === "This month") {
      let today = new Date();
      let thisMonth = today.toLocaleString("en-US", { month: "short" }) + String(today.getFullYear());
      sortedData = totalProducts.filter((product) => {
        let prodctMonth = product.order_date.split(" ")[2] + product.order_date.split(" ")[3];
        return thisMonth === prodctMonth;
      });
    }

    if (time.split(" ")[0] === "Year") {
      dropDownYears.forEach((year) => {
        if (time === `Year (${year - 1}-${year})`) {
          sortedData = totalProducts.filter((product) => {
            return (
              String(year) === product.order_date.split(" ")[3] ||
              String(year - 1) === product.order_date.split(" ")[3]
            );
          });
        }
      });
    }

    setOrder(sortedData);
  };

  if (!auth) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
        <MainHeader />
        <section className="container min-height60">
          <div className="sticky-section">
            <Link to={"/home"} className="es-link colored font-16 ">
              <svg viewBox="0 0 54 128" height="16" width="11">
                <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
              </svg>
              &nbsp;Back to home
            </Link>
            <h1 className="margin-top-10p ">Order History</h1>
          </div>

          {totalProducts.length ? (
            <div className="container padding-left-0p ">
              <div className="sticky-search">
                <div className="row margin-bottom-40 space-between ">
                  <div className="col-md-9 width-55">
                    <div className="es-input-text search-term">
                      <input
                        id="searchKeyword"
                        type="text"
                        name="searchKeyword"
                        placeholder="&nbsp;"
                        onChange={handleChange}
                        value={searchKeyword}
                      />
                      <label htmlFor="searchKeyword" className="search-label">
                        <h3 className="order-history-search">
                          Search by Order number
                        </h3>
                      </label>
                      <button
                        onClick={findProducts}
                        className="search-button search-button-order-history"
                        type="button"
                      >
                        <img src={search} alt="search" />
                      </button>
                    </div>
                  </div>

                  <div className="col-md-3 sort-box-order-history width-20">
                    <button
                      onClick={toggleFiltering}
                      className="dropdown-button background-white border-bottom-ash sort-box-order-history "
                      id="button"
                    >
                      <span>{filterLabel ? filterLabel : "Recent"}</span>
                      <svg
                        className={
                          toggleFilter ? "arrow-down-svg" : "arrow-up-svg"
                        }
                        width="16"
                        height="10"
                        viewBox="0 0 16 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          className={toggleFilter ? "" : "arrow-up-svg-color"}
                          d="M0 1.23529L1.23529 0L7.94118 6.70588L14.6471 0L15.8824 1.23529L7.94118 9.17647L0 1.23529Z"
                          fill="#007398"
                        />
                      </svg>
                    </button>

                    <div
                      className={
                        toggleFilter
                          ? "dropdown-container fixed-dropdown dropdown-container-hidden font-16 width-90 "
                          : "dropdown-container width-90 fixed-dropdown font-16"
                      }
                    >
                      <div key="latest" className="dropdown-items">
                        <label
                          onClick={handleFiltering}
                          className="select-item no-input pointer"
                          htmlFor="Last week"
                        >
                          Last week
                        </label>
                        <input
                          className="dropdwn-option"
                          id="Last week"
                          type="radio"
                          value="Last week"
                        />
                      </div>
                      <div key="This month" className="dropdown-items">
                        <label
                          onClick={handleFiltering}
                          className="select-item no-input pointer"
                          htmlFor="This month"
                        >
                          This month
                        </label>
                        <input
                          className="dropdwn-option"
                          id="This month"
                          type="radio"
                          value="This month"
                        />
                      </div>

                      {dropDownYears.map((year) => (
                        <div key={year} className="dropdown-items">
                          <label
                            onClick={handleFiltering}
                            className="select-item no-input pointer"
                            htmlFor={`Year (${year - 1}-${year})`}
                          >
                            {`Year (${year - 1}-${year})`}
                          </label>
                          <input
                            className="dropdwn-option"
                            id={`Year (${year - 1}-${year})`}
                            type="radio"
                            value={`Year (${year - 1}-${year})`}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {order.length ? (
                <table className="table table-borderless ">
                  <thead className="cart-table-header sticky-table-head">
                    <tr>
                      <td className="padding-left-0p">Reference number</td>
                      <td>Order No</td>
                      <td>Order on</td>
                      <td>Grand Total</td>
                      <td>Status</td>
                    </tr>
                  </thead>
                  <tbody>
                    {order.map((element) => (
                      <tr key={element.reference_number}>
                        <td className="font-16 padding-left-0p ">
                          <Link
                            className="es-link colored"
                            to={`/orderHistory/${element.order_number}`}
                          >
                            {element.order_number}
                          </Link>
                        </td>
                        <td className="color-light-ash font-16">
                          {element.reference_number}
                        </td>
                        <td className="color-light-ash font-16">
                          {formattedDate(element.order_date)}
                        </td>
                        <td className="font-16">
                          ₹&nbsp;{indianCurrencyFormat(element.grant_total)}
                        </td>
                        <td className="color-light-ash font-16">
                          {element.title_status}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="no-results-container">
                  <h1 className="no-results-found">
                    <svg
                      className="no-results-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 128"
                      height="24"
                      width="19"
                    >
                      <path d="M19.22 76.91c-5.84-5.84-9.05-13.6-9.05-21.85s3.21-16.01 9.05-21.85c5.84-5.83 13.59-9.05 21.85-9.05 8.25 0 16.01 3.22 21.84 9.05 5.84 5.84 9.05 13.6 9.05 21.85s-3.21 16.01-9.05 21.85c-5.83 5.83-13.59 9.05-21.84 9.05-8.26 0-16.01-3.22-21.85-9.05zm80.33 29.6L73.23 80.19c5.61-7.15 8.68-15.9 8.68-25.13 0-10.91-4.25-21.17-11.96-28.88-7.72-7.71-17.97-11.96-28.88-11.96S19.9 18.47 12.19 26.18C4.47 33.89.22 44.15.22 55.06s4.25 21.17 11.97 28.88C19.9 91.65 30.16 95.9 41.07 95.9c9.23 0 17.98-3.07 25.13-8.68l26.32 26.32 7.03-7.03" />
                    </svg>
                    <span>
                      No results found. Try another set of filters or keyword
                    </span>
                  </h1>
                </div>
              )}
            </div>
          ) : (
            <div className="container no-result-container">
              <h3>No orders</h3>
            </div>
          )}
        </section>
        <Footer />
      </React.Fragment>
    );
  }
};

export default OrderHistory;